import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MainService } from 'src/app/services/main.service';
import { UUID } from 'angular2-uuid';
import { CookieService } from '../../../../node_modules/ngx-cookie-service';

@Component({
  selector: 'app-favorite-button',
  templateUrl: './favorite-button.component.html',
  styleUrls: ['./favorite-button.component.scss']
})
export class FavoriteButtonComponent implements OnInit {


  ipAddress: any;

  @Input()
  large = false

  @Input()
  fundid = ''

  @Input()
  curr = ''

  @Input()
  inCard = false

  @Input()
  active = false

  @Input()
  disabled = false

  constructor(private http: HttpClient,
    private _mainService: MainService,
    private cookieService: CookieService) {

  }

  toggleStatus() {
    if (!this.disabled) {
      this.active = !this.active
    }

    if (this.active == true) {
      this._mainService.add_IsFav(localStorage.getItem('uuid_'), this.fundid, this.curr).subscribe(response => {
        // this.announceFavNum(response["favNum"])
        this._mainService.get_FavNum(localStorage.getItem('uuid_')).subscribe(response => {
          localStorage.setItem('favNum', response["favNum"]);
          this.announceFavNum(response["favNum"])
        })
      })
    } else {
      this._mainService.delIsFav(localStorage.getItem('uuid_'), this.fundid, this.curr).subscribe(response => {
        // this.announceFavNum(response["favNum"])
        this._mainService.get_FavNum(localStorage.getItem('uuid_')).subscribe(response => {
          localStorage.setItem('favNum', response["favNum"]);
          this.announceFavNum(response["favNum"])
        })
      })
    }

    // this.http.get<{ ip: string }>('https://jsonip.com')
    //   .subscribe(data => {



    //     // this._mainService.get_FavNum(data.ip).subscribe(response => {

    //     //   localStorage.setItem('favNum', response["favNum"]);
    //     //   this.announceFavNum(response["favNum"])

    //     // })
    //   })
  }

  announceFavNum(favNum) {
    this._mainService.announceFavNum(favNum)
  }

  ngOnInit() {
    this._mainService.get_IsFav(localStorage.getItem('uuid_'), this.fundid, this.curr).subscribe(response => {
      if (response['isFav'] == "y") {
        this.active = true;
      }
      else {
        this.active = false;
      }
    })
  }
}
